<div class="filter-toggle-container">
  <span class="filter-label">{{ (showOnlyUnread ? 'FILTER.UNREAD' : 'FILTER.ALL') | translate }}</span>
  <mat-slide-toggle
    class="slide-toggle" 
    [checked]="showOnlyUnread"
    (change)="onToggleChange($event)"
    [disableRipple]="true"
    [aria-label]="(showOnlyUnread ? 'FILTER.UNREAD' : 'FILTER.ALL') | translate">
  </mat-slide-toggle>
</div>